import clsx from "clsx";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	icon?: React.ReactNode;
	showIcon?: boolean;
	highlightText?: boolean;
};

const TimeTrackingFormHeader = ({ icon, children, highlightText = false, showIcon = false }: Props) => {
	return <div className="flex flex-row items-center gap-x-3">
		{(showIcon && !!icon) ? icon : null}
		<div className={clsx("text-xl font-bold", !highlightText ? "text-primary-500" : "text-red-500")}>{children}</div>
	</div>;
};

export default TimeTrackingFormHeader;